




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class MainHeaderView extends Vue {
  @Prop()
  private cState: any;
  private ifShowMenu: boolean = false;
  @Prop()
  private ifCdr: any;
  @Prop()
  private projectName: any;
  private get user() {
    return this.$store.state.user;
  }
  private get ifLowHeight() {
    if (window.innerHeight <= 670) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @description 跳转
   */
  private jump(url) {
    this.$router.push(url);
  }
  /**
   * @description 登出
   */
  private logout() {
    this.$store.commit("updateToken", "");
    this.$router.push("/");
  }
}
